export const setErrors = (state, errors) => {
  state.errorsList = errors;
};
export const toggleShowErrorsModal = (state, toggle) => {
  state.showErrorsModal = toggle;
};
export const setState = (state, { key, value }) => {
  state[key] = value;
};
export const addEnty = (state, { key, value }) => {
  console.log("LA DATA PARA EL STORE: ", state[key], value);
  state[key] = [value, ...state[key]];
};
export const setZohoConfigData = (state, { is_zoho_activated, form }) => {
  state.zohoCrm.isZohoActivated = is_zoho_activated;
  state.zohoCrm.form = form;
};
export const setZohoDeskConfigData = (
  state,
  { is_zoho_activated, form, zoho_client_id, zoho_client_secret }
) => {
  state.zohoDesk.isZohoActivated = is_zoho_activated;
  state.zohoDesk.form = form;
  state.zohoDesk.zoho_client_id = zoho_client_id;
  state.zohoDesk.zoho_client_secret = zoho_client_secret;
};
export const setZohoUserData = (state, { form }) => {
  state.zohoUser.form = form;
};
export const updateState = (state, { key, results, keySearch, value }) => {
  console.log(state[key][results], keySearch, value[keySearch]);
  let index = state[key][results].findIndex(
    (item) => item[keySearch] === value[keySearch]
  );
  console.log("INDEX: ", index);
  state[key][results][index] = value;
};
export const addEntyResults = (state, { key, value }) => {
  console.log("LA DATA PARA EL STORE: ", state[key], value);
  state[key]['results'] = [value, ...state[key]['results']];
};
